// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import TimerIcon from '@material-ui/icons/Timer';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Box from "@material-ui/core/Box";


const useStyles = makeStyles(theme => ({
    root: {
        position: 'sticky',
        top: 0,
        backgroundColor: theme.palette.common.white,
        zIndex: 1
    },
    button: {
        textTransform: 'inherit'
    }
}));

type ActiveButtonProps = $ReadOnly<{
    duration: number,
    onClick: (duration: number) => void
}>;

const ActivateButton = ({duration, onClick, ...other}: ActiveButtonProps) => {
    const handleClick = () => onClick(duration);

    return (
        <Button
            onClick={handleClick}
            {...other}
        >
            {duration}&nbsp;
            <FormattedMessage
                id="sidebar.zones.min"
                defaultMessage="min"
            />
        </Button>
    );
};

type Props = $ReadOnly<{
    durations: $ReadOnlyArray<number>,
    disabled: boolean,

    onActivate: (duration?: number) => void
}>;

function ZoneListControls({ durations, disabled, onActivate }: Props) {
    const classes = useStyles();

    const anchorRef = React.useRef(null);

    const handleActivate = (duration) => onActivate(duration && (parseInt(duration, 10) * 60000) );

    return (
        <Box px={1} py={2} className={classes.root} display="flex" alignItems="center" justifyContent="space-between">
            <TimerIcon style={{ marginRight: '.5ch' }}/>
            <ButtonGroup disabled={disabled} fullWidth={true} size="small" variant="contained" color="primary" ref={anchorRef}>
                {durations.map((option, index) => (
                    <ActivateButton key={index} duration={option} onClick={handleActivate} className={classes.button}/>
                ))}
            </ButtonGroup>
        </Box>
    );
}

export default ZoneListControls;